module.exports = __webpack_public_path__ + "cb8ba92953900108993fddd9a4713554.svg";